import { CHURCHILL_BRAND } from '../config/services'

const autoGuestLogin = () => {
  if (CHURCHILL_BRAND) {
    return true
  }

  return false
}

export default autoGuestLogin



// WEBPACK FOOTER //
// ./src/utility/autoGuestLogin.js